export const LABEL_WIDTH = 17;
